module.exports = __webpack_public_path__ + "static/media/black-logo.8688d0e1.png";